import { createContext, useMemo, useState } from 'react';

import { BreadcrumbType, Grid } from 'types';

type LayoutProps = {
  children: React.ReactNode;
};

export type Layout = {
  breadcrumb: BreadcrumbType[];
  breadcrumbSet: Function;
  breadcrumbSecondary: BreadcrumbType[];
  breadcrumbSecondarySet: Function;
  additionalInfo: string[];
  additionalInfoSet: Function;
  grid: Grid;
  gridSet: Function;
  isOrderModalVisible: boolean;
  isOrderModalVisibleSet: (arg: boolean) => void;
};

const defaultState: Layout = {
  breadcrumb: [],
  breadcrumbSet: () => null,
  breadcrumbSecondary: [],
  breadcrumbSecondarySet: () => null,
  additionalInfo: [],
  additionalInfoSet: () => null,
  grid: 'layout',
  gridSet: () => null,
  isOrderModalVisible: false,
  isOrderModalVisibleSet: () => null,
};

export const LayoutContext = createContext(defaultState);

export const LayoutProvider: React.FunctionComponent<LayoutProps> = ({ children }) => {
  const [breadcrumb, breadcrumbSet] = useState<BreadcrumbType[]>([]);
  const [breadcrumbSecondary, breadcrumbSecondarySet] = useState<BreadcrumbType[]>([]);
  const [additionalInfo, additionalInfoSet] = useState<string[]>([]);
  const [isOrderModalVisible, isOrderModalVisibleSet] = useState<boolean>(false);
  const [grid, gridSet] = useState<Grid>('layout');

  const state: Layout = useMemo(
    () => ({
      breadcrumb,
      breadcrumbSet,
      breadcrumbSecondary,
      breadcrumbSecondarySet,
      additionalInfo,
      additionalInfoSet,
      grid,
      gridSet,
      isOrderModalVisible,
      isOrderModalVisibleSet,
    }),
    [breadcrumb, breadcrumbSecondary, grid, additionalInfo, isOrderModalVisible]
  );

  return <LayoutContext.Provider value={state}>{children}</LayoutContext.Provider>;
};
